import { request } from "./http";

export interface Withdrawal {
  id: string;
  trading_account_id: string;
  requested_by: string;
  amount: string;
  currency: string;
  destination: Record<string, unknown>;
  status: "PENDING" | "APPROVED" | "REJECTED" | "PAID" | "CANCELED";
  note: string | null;
  decision_note: string | null;
  decided_by: string | null;
  decided_at: string | null;
  created_at: string;
}

export interface WithdrawalCreate {
  trading_account_id: string;
  amount: string | number;
  currency?: string;
  destination?: Record<string, unknown>;
  note?: string;
}

export const withdrawals = {
  listMine: () => request<Withdrawal[]>("/api/v1/withdrawals"),
  request: (body: WithdrawalCreate) => request<Withdrawal>("/api/v1/withdrawals", { body }),
  cancel: (id: string) =>
    request<Withdrawal>(`/api/v1/withdrawals/${id}/cancel`, { body: {} }),
  adminPending: () => request<Withdrawal[]>("/api/v1/withdrawals/admin/pending"),
  adminAll: (limit = 200) => request<Withdrawal[]>(`/api/v1/withdrawals/admin?limit=${limit}`),
  approve: (id: string, note?: string) =>
    request<Withdrawal>(`/api/v1/withdrawals/${id}/approve`, { body: { note } }),
  reject: (id: string, note?: string) =>
    request<Withdrawal>(`/api/v1/withdrawals/${id}/reject`, { body: { note } }),
  markPaid: (id: string, note?: string) =>
    request<Withdrawal>(`/api/v1/withdrawals/${id}/mark-paid`, { body: { note } }),
};
